import React from "react";
import "./SendLove.css";

export default function SendLove({ onPrimaryClick, onSecondaryClick }) {
  return (
    <section className="send-love" aria-label="Flower delivery hero">
      <div className="send-love__overlay" />

      <div className="send-love__content">
        <p className="send-love__eyebrow">Fresh. Handcrafted. Same-Day.</p>

        <h1 className="send-love__title">
          Send love in every <span>petal</span>
        </h1>

        <p className="send-love__subtitle">
          Curated bouquets by local florists—delivered with care in as little as{" "}
          <strong>2 hours</strong>.
        </p>

        <form
          className="send-love__cta"
          onSubmit={(e) => {
            e.preventDefault();
            onPrimaryClick && onPrimaryClick();
          }}
        >
          <div className="send-love__inputWrap">
            <input
              className="send-love__input"
              type="text"
              inputMode="text"
              placeholder="Enter city or area (e.g., Beirut)"
              aria-label="Enter your delivery city"
            />
            <button className="send-love__btn send-love__btn--primary" type="submit">
              Shop bouquets
            </button>
          </div>

          <button
            className="send-love__btn send-love__btn--ghost"
            type="button"
            onClick={onSecondaryClick}
          >
            Same-day delivery
          </button>
        </form>

        <ul className="send-love__badges" aria-label="Benefits">
          <li>✨ Hand-tied by experts</li>
          <li>🚚 Real-time delivery tracking</li>
          <li>💌 Free personalized note</li>
        </ul>

        <div className="send-love__chips" aria-label="Popular occasions">
          <button className="chip">Birthday</button>
          <button className="chip">Love & Romance</button>
          <button className="chip">Thank You</button>
          <button className="chip">New Baby</button>
        </div>
      </div>
    </section>
  );
}
